import { render, staticRenderFns } from "./header_widget.vue?vue&type=template&id=d2e49af0&scoped=true&lang=pug"
import script from "./header_widget.vue?vue&type=script&lang=js"
export * from "./header_widget.vue?vue&type=script&lang=js"
import style0 from "./header_widget.vue?vue&type=style&index=0&id=d2e49af0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e49af0",
  null
  
)

export default component.exports